import { AccountHolder } from "../components/Account";
import { BranchLimitsHolder } from "../components/BranchLimits";
import { ListService } from "../components/pages/account/ListService";
import {
  AudienceHolder,
  AudienceType,
  ResultsViewHolder,
} from "../components/pages/search/ls/LSSearch";

export function clearAccountData() {
  AccountHolder.clearAccountData();
  ListService.clearListData();
}
export function clearSearchHistory() {
  BranchLimitsHolder.setSelectedBranchIds([]);
  AudienceHolder.setAudience(AudienceType.AllAges);
  ResultsViewHolder.setResultsView(null);
}
